<template>
    <div class="professional-not-found">
      <div class="content-container">
        <div class="error-graphic">
          <div class="error-code">404</div>
        </div>
        <h1 class="error-title">Lapa nav atrasta</h1>
        <p class="error-message">
          Lapa, ko jūs meklējat, nav pieejama. Iespējams tā ir pārvietota, dzēsta, vai varbūt nekad nav eksistējusi.
        </p>
        <div class="action-buttons">
          <router-link to="/workspace/dashboard" class="primary-btn">Atgriezties mājās</router-link>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'NotFoundPage',
    methods: {
      goBack() {
        window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
      }
    }
  }
  </script>
  
  <style>
  .professional-not-found {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 90vh;
    padding: 20px;
  }
  
  .content-container {
    max-width: 600px;
    text-align: center;
    background-color: var(--background-table);
    border-radius: 32px;
    padding: 40px;
  }
  
  .error-graphic {
    margin: 0;
    position: relative;
    padding: 0;
  }
  
  .error-code {
    font-size: 80px;
    font-weight: 600;
    color: var(--main-color);
    letter-spacing: 2px;
  }
  
  .error-title {
    font-size: 28px;
    margin-bottom: 16px;
    margin-top: 0;
    font-weight: 500;
    margin-bottom: 0;
  }

  .error-message {
    margin-top: 5px;
    margin-bottom: 20px;
  }

  .action-buttons {
    display: flex;
    justify-content: center;
  }

  .primary-btn {
    text-decoration: none;
  }
  
  @media (max-width: 640px) {
    .content-container {
      padding: 30px 20px;
    }
    
    .error-code {
      font-size: 60px;
    }
    
    .error-title {
      font-size: 24px;
    }
    
    .action-buttons {
      flex-direction: column;
      gap: 12px;
    }
  }
  </style>